import { render, staticRenderFns } from "./salinvalidsetting.vue?vue&type=template&id=2a4dcbb6&scoped=true&"
import script from "./salinvalidsetting.vue?vue&type=script&lang=js&"
export * from "./salinvalidsetting.vue?vue&type=script&lang=js&"
import style0 from "./salinvalidsetting.vue?vue&type=style&index=0&id=2a4dcbb6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4dcbb6",
  null
  
)

export default component.exports